/** Returned when Redis SET for the session blob fails. */
export const WORKFLOW_SYNC_SAVE_CONFLICT_ERROR =
  "Could not save workflow session";

export const WORKFLOW_ALREADY_RUNNING_ERROR =
  "A workflow session is already active.";

/** How long the end-of-session summary toast stays visible (ms). */
export const WORKFLOW_SESSION_SUMMARY_TOAST_DURATION_MS = 8_000;

/** Unused client-side; persisted so existing Redis sessions still parse. */
export const WORKFLOW_REDIS_LEGACY_DAILY_GOAL = 15;
export const WORKFLOW_REDIS_LEGACY_AUTO_ADVANCE = true;

/** Client inactivity checker interval. The timeout itself is 1 hour. */
export const WORKFLOW_INACTIVITY_CHECK_INTERVAL_MS = 5 * 60 * 1000;
/** Auto-end a session this long after its latest call activity anchor. */
export const WORKFLOW_INACTIVITY_TIMEOUT_MS = 3_600_000;

// ---------------------------------------------------------------------------
// Queue day
// ---------------------------------------------------------------------------

/** Autodialer queue day starts at this ET hour and runs 24 hours. */
export const AUTODIALER_QUEUE_DAY_START_HOUR_ET = 7;

/**
 * Active working queue: tasks due from this many 7am–7am ET days ago
 * through the next 7am ET. Ranked as one stack by the priority table.
 */
export const AUTODIALER_ACTIVE_QUEUE_LOOKBACK_DAYS = 5;

// ---------------------------------------------------------------------------
// Scheduled-call window
// ---------------------------------------------------------------------------

/**
 * Client-requested times in this inclusive local window (client timezone)
 * are scheduled calls. 7:00 AM through 9:00 PM.
 */
export const SCHEDULED_CALL_START_HOUR = 7;
export const SCHEDULED_CALL_END_HOUR = 21;

/** Prompt when a held scheduled call is due within this many minutes. */
export const SCHEDULED_CALL_PROMPT_WINDOW_MINUTES = 10;
